import { useOrderReadyNotifier } from '../hooks/useOrderReadyNotifier'

/**
 * Headless component that runs the order-ready notifier hook while mounted.
 * Rendered under App only when self-order is enabled AND there is someone whose
 * orders we can watch — a logged-in customer **or a guest who has ordered**
 * (#2140: 卓の QR からログインせずに注文したお客様にも「提供しました」を出す。
 * 以前はログインした客だけで、ゲストには音もお知らせも出なかった)。
 * Guests who never ordered (a guest id also comes from stamp rallies etc.) are
 * not watched — see `hasGuestOrdered`.
 */
export default function OrderReadyNotifierMount() {
  useOrderReadyNotifier()
  return null
}
